import React, { memo } from 'react';

const CustomerSection = ({
  selectedCustomer,
  customerSearchQuery,
  showCustomerSuggestions,
  customerSuggestions,
  customerSearchLoading,
  error,
  onSearchQueryChange,
  onSelectCustomer,
  onRemoveCustomer,
  onEditCustomer,
  onShowHistory,
  onShowAddModal,
  onLoadAllCustomers,
  onShowSuggestions,
  onHideSuggestions,
  onCheckCoupon
}) => {
  const getCustomerDisplayName = (customer) => {
    return (customer.nazwa_firmy && customer.nazwa_firmy.trim()) ||
      (customer.name && customer.name.trim()) ||
      `${(customer.imie || "").trim()} ${(customer.nazwisko || "").trim()}`.trim() ||
      customer.email ||
      customer.phone ||
      `#${customer.id}`;
  };

  return (
    <>
      {/* Kompaktowa sekcja klienta — inline w CartHeader */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <i className="fas fa-user" style={{ color: "var(--text-muted)", fontSize: "0.7rem" }}></i>

        <div style={{ flex: 1, position: "relative", maxWidth: "300px" }}>
          {selectedCustomer ? (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "0.5rem",
                padding: "0.25rem 0.5rem",
                backgroundColor: "var(--success-light)",
                borderRadius: "0.25rem",
                border: "1px solid var(--success-light)",
              }}
            >
              <span style={{ fontSize: "0.75rem", fontWeight: "500", color: "var(--success)" }}>
                {getCustomerDisplayName(selectedCustomer)}
              </span>
              {selectedCustomer.phone && (
                <span style={{ fontSize: "0.7rem", color: "var(--success)" }}>📞 {selectedCustomer.phone}</span>
              )}
              <button
                data-pos-btn="true"
                onClick={onShowHistory}
                style={{
                  marginLeft: "auto",
                  background: "none",
                  border: "1px solid var(--success)",
                  color: "var(--success)",
                  fontSize: "11px",
                  padding: "4px 10px",
                }}
                title="Historia zakupów klienta"
              >
                📋 Historia
              </button>
              <button
                data-pos-btn="true"
                onClick={onEditCustomer}
                style={{
                  background: "none",
                  border: "1px solid var(--success)",
                  color: "var(--success)",
                  fontSize: "11px",
                  padding: "4px 10px",
                }}
                title="Edytuj dane klienta"
              >
                ✏️ Edytuj
              </button>
              <button
                data-pos-btn="true"
                onClick={onRemoveCustomer}
                style={{
                  background: "none",
                  border: "none",
                  color: "var(--danger)",
                  fontSize: "0.8rem",
                  padding: "0 0.25rem"
                }}
                title="Usuń klienta"
              >
                ✕
              </button>
            </div>
          ) : (
            <>
              <input
                type="text"
                placeholder="Wyszukaj lub wybierz..."
                value={customerSearchQuery}
                onChange={(e) => onSearchQueryChange(e.target.value)}
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: "1px solid var(--border)",
                  borderRadius: "6px",
                  fontSize: "12px",
                  backgroundColor: "var(--card-bg)",
                  color: "var(--text)",
                  outline: "none",
                }}
                onFocus={(e) => {
                  e.target.style.borderColor = "var(--info)";
                  if (customerSearchQuery.length >= 2) onShowSuggestions();
                }}
                onBlur={(e) => {
                  e.target.style.borderColor = "var(--border)";
                  setTimeout(() => onHideSuggestions(), 150);
                }}
              />
              {/* Podpowiedzi */}
              {showCustomerSuggestions && customerSuggestions.length > 0 && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "var(--card-bg)",
                    border: "1px solid var(--border)",
                    borderTop: "none",
                    borderRadius: "0 0 0.25rem 0.25rem",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    zIndex: 1000,
                    maxHeight: "150px",
                    overflowY: "auto",
                  }}
                >
                  {customerSuggestions.map((customer) => (
                    <div
                      key={customer.id}
                      onClick={() => onSelectCustomer(customer)}
                      style={{
                        padding: "0.4rem 0.5rem",
                        fontSize: "0.75rem",
                        cursor: "pointer",
                        borderBottom: "1px solid var(--border)",
                      }}
                      onMouseEnter={(e) => (e.target.style.backgroundColor = "var(--bg)")}
                      onMouseLeave={(e) => (e.target.style.backgroundColor = "var(--card-bg)")}
                    >
                      <div style={{ fontWeight: "500" }}>
                        {getCustomerDisplayName(customer)}
                      </div>
                      {customer.phone && (
                        <span style={{ fontSize: "0.65rem", color: "var(--text-muted)" }}>📞 {customer.phone}</span>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {showCustomerSuggestions && customerSuggestions.length === 0 && customerSearchQuery.length >= 2 && !customerSearchLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: "100%",
                    left: 0,
                    right: 0,
                    background: "var(--card-bg)",
                    border: "1px solid var(--border)",
                    borderTop: "none",
                    borderRadius: "0 0 0.25rem 0.25rem",
                    padding: "0.4rem",
                    fontSize: "0.7rem",
                    color: "var(--text-muted)",
                    textAlign: "center",
                    zIndex: 1000,
                  }}
                >
                  Brak wyników
                </div>
              )}
            </>
          )}
        </div>

        {/* Przyciski */}
        <div style={{ display: "flex", gap: "0.25rem" }}>
          {!selectedCustomer && (
            <>
              <button
                data-pos-btn="true"
                onClick={onLoadAllCustomers}
                style={{
                  padding: "4px 10px",
                  fontSize: "11px",
                  border: "1px solid var(--info)",
                  backgroundColor: "var(--info-light)",
                  color: "var(--info)",
                }}
                title="Pokaż listę klientów"
              >
                📋
              </button>
              <button
                data-pos-btn="true"
                onClick={onShowAddModal}
                style={{
                  padding: "4px 10px",
                  fontSize: "11px",
                  border: "1px solid var(--success)",
                  backgroundColor: "var(--success-light)",
                  color: "var(--success)",
                }}
                title="Dodaj nowego klienta"
              >
                ➕
              </button>
            </>
          )}
          {onCheckCoupon && (
            <button
              data-pos-btn="true"
              onClick={onCheckCoupon}
              style={{
                padding: "4px 10px",
                fontSize: "11px",
                border: "1px solid var(--purple)",
                backgroundColor: "var(--purple-light)",
                color: "var(--purple)",
              }}
              title="Sprawdź stan kuponu"
            >
              🎟️ Sprawdz kupon
            </button>
          )}
        </div>
      </div>

      {error && (
        <div
          style={{
            backgroundColor: "var(--danger-light)",
            color: "var(--danger)",
            border: "1px solid var(--danger-light)",
            borderRadius: "0.375rem",
            padding: "0.75rem",
            margin: "1rem",
            display: "flex",
            alignItems: "center",
            gap: "0.5rem",
          }}
        >
          <i className="fas fa-exclamation-triangle"></i>
          {error}
        </div>
      )}
    </>
  );
};

export default memo(CustomerSection);
